import {
  GET_TRACKING_IMAGES,
  GET_TRACKING_IMAGES_SUCCESS,
  GET_TRACKING_IMAGES_ERROR,
  GET_TRACKING_IMAGE,
  GET_TRACKING_IMAGE_SUCCESS,
  GET_TRACKING_IMAGE_ERROR,
  ADD_TRACKING_IMAGE,
  ADD_TRACKING_IMAGE_SUCCESS,
  ADD_TRACKING_IMAGE_ERROR,
  EDIT_TRACKING_IMAGE,
  EDIT_TRACKING_IMAGE_SUCCESS,
  EDIT_TRACKING_IMAGE_ERROR,
  DELETE_TRACKING_IMAGE,
  DELETE_TRACKING_IMAGE_SUCCESS,
  DELETE_TRACKING_IMAGE_ERROR,
  RESET_TRACKING_IMAGE_FLAG,
} from "./actionTypes"

export const getTrackingImages = () => {
  return {
    type: GET_TRACKING_IMAGES,
  }
}

export const getTrackingImagesSuccess = images => {
  return {
    type: GET_TRACKING_IMAGES_SUCCESS,
    payload: { images },
  }
}

export const getTrackingImagesError = error => {
  return {
    type: GET_TRACKING_IMAGES_ERROR,
    payload: error,
  }
}

export const getTrackingImage = uid => {
  return {
    type: GET_TRACKING_IMAGE,
    payload: { uid },
  }
}

export const getTrackingImageSuccess = tracking => {
  return {
    type: GET_TRACKING_IMAGE_SUCCESS,
    payload: { tracking },
  }
}

export const getTrackingImageError = error => {
  return {
    type: GET_TRACKING_IMAGE_ERROR,
    payload: error,
  }
}

export const addTrackingImage = trackingImageForm => {
  return {
    type: ADD_TRACKING_IMAGE,
    payload: { trackingImageForm },
  }
}

export const addTrackingImageSuccess = message => {
  return {
    type: ADD_TRACKING_IMAGE_SUCCESS,
    payload: message,
  }
}

export const addTrackingImageError = error => {
  return {
    type: ADD_TRACKING_IMAGE_ERROR,
    payload: error,
  }
}

export const editTrackingImage = tracking => {
  return {
    type: EDIT_TRACKING_IMAGE,
    payload: { tracking },
  }
}

export const editTrackingImageSuccess = message => {
  return {
    type: EDIT_TRACKING_IMAGE_SUCCESS,
    payload: message,
  }
}

export const editTrackingImageError = error => {
  return {
    type: EDIT_TRACKING_IMAGE_ERROR,
    payload: error,
  }
}

export const deleteTrackingImage = image => {
  return {
    type: DELETE_TRACKING_IMAGE,
    payload: { image },
  }
}

export const deleteTrackingImageSuccess = message => {
  return {
    type: DELETE_TRACKING_IMAGE_SUCCESS,
    payload: message,
  }
}

export const deleteTrackingImageError = error => {
  return {
    type: DELETE_TRACKING_IMAGE_ERROR,
    payload: error,
  }
}

export const resetTrackingImageFlag = () => {
  return {
    type: RESET_TRACKING_IMAGE_FLAG,
  }
}
